export interface ICountry {
  ID: number;
  Code: string;
  Name: string;
  Description: string;
  IsEuropean: boolean;
}

export class Country implements ICountry {
  ID: number;
  Code: string;
  Name: string;
  Description: string;
  IsEuropean: boolean;

  constructor();
  constructor(obj: ICountry);
  constructor(obj?: ICountry) {
    this.ID = obj?.ID ?? -1;
    this.Code = obj?.Code ?? '';
    this.Name = obj?.Name ?? '';
    this.Description = obj?.Description ?? '';
    this.IsEuropean = obj?.IsEuropean ?? false;
  }
}
